module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pt-sans conteudo-relat-pedidos",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "ma-0": "",
      "pa-0": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "bcg",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm1": ""
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "margin": "19px 0 0 0"
    }
  }, [_c('strong', [_vm._v(" Período: ")])])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": "",
      "md2": ""
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "De",
            "prepend-icon": "event",
            "readonly": ""
          },
          model: {
            value: (_vm.computedDateFormattedFrom),
            callback: function($$v) {
              _vm.computedDateFormattedFrom = $$v
            },
            expression: "computedDateFormattedFrom"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "pt-br"
    },
    on: {
      "input": function($event) {
        _vm.menu = false
      }
    },
    model: {
      value: (_vm.dateFrom),
      callback: function($$v) {
        _vm.dateFrom = $$v
      },
      expression: "dateFrom"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": "",
      "md2": "",
      "spacing": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Até",
            "prepend-icon": "event",
            "readonly": ""
          },
          model: {
            value: (_vm.computedDateFormattedTo),
            callback: function($$v) {
              _vm.computedDateFormattedTo = $$v
            },
            expression: "computedDateFormattedTo"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu2),
      callback: function($$v) {
        _vm.menu2 = $$v
      },
      expression: "menu2"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "pt-br"
    },
    on: {
      "input": function($event) {
        _vm.menu2 = false
      }
    },
    model: {
      value: (_vm.dateTo),
      callback: function($$v) {
        _vm.dateTo = $$v
      },
      expression: "dateTo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "spacing": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.statusName,
      "chips": "",
      "label": "Selecione os status",
      "multiple": "",
      "outline": ""
    },
    model: {
      value: (_vm.selectedStatus),
      callback: function($$v) {
        _vm.selectedStatus = $$v
      },
      expression: "selectedStatus"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "spacing": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.fornecedoresDescription,
      "chips": "",
      "label": "Selecione os fornecedores",
      "multiple": "",
      "outline": ""
    },
    model: {
      value: (_vm.selectedFornecedores),
      callback: function($$v) {
        _vm.selectedFornecedores = $$v
      },
      expression: "selectedFornecedores"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm1": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "large": "",
      "color": "primary",
      "block": "",
      "dark": ""
    },
    on: {
      "click": _vm.pesquisar
    }
  }, [_c('v-icon', [_vm._v("search")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "s12": "",
      "justify-right": "",
      "botoes-relatorio": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "large": "",
      "color": "primary",
      "dark": "",
      "spacing": ""
    },
    on: {
      "click": _vm.exportToCsv
    }
  }, [_c('v-icon', [_vm._v("get_app")]), _vm._v("  Exportar para excel ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "large": "",
      "color": "primary",
      "dark": "",
      "spacing": ""
    },
    on: {
      "click": function($event) {
        return _vm.prepareData('export')
      }
    }
  }, [_c('v-icon', [_vm._v("archive")]), _vm._v("   Exportar para PDF ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "large": "",
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.prepareData('print')
      }
    }
  }, [_c('v-icon', [_vm._v("print")]), _vm._v("   Imprimir")], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "s12": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\r\n              Pedidos\r\n              "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "busca por texto ...",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "pagination": _vm.pagination,
      "headers": _vm.headers,
      "items": _vm.pedidosReport,
      "search": _vm.search
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.data))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.nro))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.itens))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.qtd))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.fornecedor))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.condominio))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.adm))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.morador))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.phone))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.unidade))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.valor))])]
      }
    }, {
      key: "no-results",
      fn: function() {
        return [_c('v-alert', {
          attrs: {
            "value": true,
            "color": "error",
            "icon": "warning"
          }
        }, [_vm._v("\r\n                  Sua pesquisa \"" + _vm._s(_vm.search) + "\" não encontrou resultados.\r\n                ")])]
      },
      proxy: true
    }])
  })], 1)], 1), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f8dd9bc4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/relatorios/pedidos/index.vue
// module id = 778
// module chunks = 4